const breakpoints = {
  mobile: `768px`,
  portrait: `1024px`,
  tablet: `1200px`,
  wide: `1440px`,
};

export { breakpoints };
